export default {"src":"/_next/static/media/logo-6.a50afdd7.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};